/*
 * @Author: Teemo Ding
 * @Date: 2021-08-06 11:42:42
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-10-09 13:56:30
 * @FilePath: /unifyxp-v2-store-portal/src/pages/CustomerDatabaseConfig/CustomerDatabaseSettings/ThirdPartyLogin/index.tsx
 */
import { Button, Checkbox, TextArea } from '@/src/components/Antd';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import { copyToClip } from '@/src/tools/helper';
import { Form, message } from 'antd';
import React, { Fragment } from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';
import css from '../css.module.less';

enum ProviderType {
  Facebook = 'Facebook',
  Google = 'Google',
  Microsoft = 'Microsoft',
  Apple = 'Apple',
}

const ThirdPartyLogin = ({ salesChannelDomains, disabled }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);

  const keyNames = {
    [ProviderType.Facebook]: getI18n(
      'customerDatabaseSetting.thirdPartyLogin.appID',
    ),
    [ProviderType.Google]: getI18n(
      'customerDatabaseSetting.thirdPartyLogin.clientID',
    ),
    [ProviderType.Microsoft]: getI18n(
      'customerDatabaseSetting.thirdPartyLogin.applicationID',
    ),
    [ProviderType.Apple]: getI18n(
      'customerDatabaseSetting.thirdPartyLogin.serviceID',
    ),
  };
  const keys = Object.keys(ProviderType);
  const copyURl = () => {
    copyToClip(salesChannelDomains.join(','));
    message.success(
      getI18n('customerDatabaseSetting.thirdPartyLogin.clipboard'),
    );
  };
  return (
    <div className={css.itemBlock}>
      <SectionWrapper
        titleClassName={css.titleContainer}
        containerClassName={css.thirdPartyLogin}
        title={getI18n(
          'customerDatabaseSetting.thirdPartyLogin.thirdPartyLogin',
        )}>
        {keys.map((key) => (
          <div key={key} className={css.thirdPartyLoginItem}>
            <Form.Item name={`${key}_enabled`} valuePropName='checked'>
              <Checkbox disabled={disabled}>
                {replaceI18nVariables(
                  getI18n(
                    'customerDatabaseSetting.thirdPartyLogin.enable${key}Login',
                  ),
                  key,
                )}
              </Checkbox>
            </Form.Item>
            <Form.Item
              noStyle
              shouldUpdate={(prevValues, curValues) =>
                prevValues[`${key}_enabled`] !== curValues[`${key}_enabled`]
              }>
              {({ getFieldValue }: any) =>
                getFieldValue(`${key}_enabled`) && (
                  <Form.Item
                    className={css.thirdPartyLoginItemItem}
                    name={`${key}_clientID`}
                    labelCol={{
                      span: 24,
                    }}
                    rules={[
                      {
                        required: true,
                        message: replaceI18nVariables(
                          getI18n(
                            'customerDatabaseSetting.thirdPartyLogin.required',
                          ),
                          keyNames[key],
                        ),
                      },
                    ]}
                    label={keyNames[key] + '*'}>
                    <TextArea
                      disabled={disabled}
                      maxLength='500'
                      autoSize={{ minRows: 1, maxRows: 1 }}
                    />
                  </Form.Item>
                )
              }
            </Form.Item>
          </div>
        ))}
        <Form.Item noStyle shouldUpdate>
          {({ getFieldsValue }: any) =>
            Object.values(
              getFieldsValue(keys.map((key) => `${key}_enabled`)),
            ).includes(true) ? (
              <div className={css.thirdPartyLoginItem}>
                {salesChannelDomains.length ? (
                  <Fragment>
                    <p>
                      {getI18n(
                        'customerDatabaseSetting.thirdPartyLogin.third_party_login',
                      )}
                    </p>
                    <div className={css.thirdPartyLoginItemText}>
                      {(salesChannelDomains || []).map((item, index) => (
                        <p key={index}>{item}</p>
                      ))}
                    </div>
                    <Button
                      type='primary'
                      ghost
                      onClick={copyURl}
                      disabled={disabled}>
                      {getI18n('customerDatabaseSetting.thirdPartyLogin.copy')}
                    </Button>
                  </Fragment>
                ) : (
                  <p>
                    {getI18n('customerDatabaseSetting.thirdPartyLogin.add')}
                  </p>
                )}
              </div>
            ) : null
          }
        </Form.Item>
      </SectionWrapper>
    </div>
  );
};

export default ThirdPartyLogin;
